import React, { useState, useLayoutEffect } from 'react'
import styled from '@emotion/styled'
import axios from 'axios'
import { isNil } from 'lodash'
import {
  Flex
} from '@mantine/core'
import {
  Link,
  Image
} from '@nextui-org/react'
import useRefresh from 'hooks/useRefresh'

const StyledFlex = styled(Flex)`
  margin-bottom: -15px;
`

const StyledLink = styled(Link)`
  svg {
    display: none;
  }
`

const SocialLinks: React.FC = () => {
  const { slowRefresh } = useRefresh()
  const [socialLinks, setSocialLinks] = useState<any>({})
  const baseUrl = `${process.env.REACT_APP_BO_LINK}api/frontend/get-social-link`

  // get social links
  useLayoutEffect(() => {
    const getAllLinks = async (): Promise<void> => {
      await axios.get(baseUrl).then((response) => {
        if (response && response.status === 200) {
          const respData = response.data.data
          setSocialLinks(respData)
        }
      })
    }

    getAllLinks()
  }, [baseUrl, slowRefresh])

  return (
    <StyledFlex
      gap="xs"
      justify="center"
      align="center"
      direction="row"
      wrap="wrap"
    >
      {!isNil(socialLinks.twitter) && socialLinks.twitter !== '' ?
        <StyledLink href={socialLinks.twitter} isExternal>
          <Image
            src="/images/twitter.svg"
            alt="Social Image"
            width={50}
          />
        </StyledLink>
        : null
      }
      {!isNil(socialLinks.discord) && socialLinks.discord !== '' ?
        <StyledLink href={socialLinks.discord} isExternal>
          <Image
            src="/images/discord.svg"
            alt="Social Image"
            width={50}
          />
        </StyledLink>
        : null
      }
      {!isNil(socialLinks.telegram) && socialLinks.telegram !== '' ?
        <StyledLink href={socialLinks.telegram} isExternal>
          <Image
            src="/images/telegram.svg"
            alt="Social Image"
            width={50}
          />
        </StyledLink>
        : null
      }
      {!isNil(socialLinks.medium) && socialLinks.medium !== '' ?
        <StyledLink href={socialLinks.medium} isExternal>
          <Image
            src="/images/medium.svg"
            alt="Social Image"
            width={50}
          />
        </StyledLink>
        : null
      }
      {!isNil(socialLinks.instagram) && socialLinks.instagram !== '' ?
        <StyledLink href={socialLinks.instagram} isExternal>
          <Image
            src="/images/instagram.svg"
            alt="Social Image"
            width={50}
          />
        </StyledLink>
        : null
      }
      {!isNil(socialLinks.facebook) && socialLinks.facebook !== '' ?
        <StyledLink href={socialLinks.facebook} isExternal>
          <Image
            src="/images/facebook.svg"
            alt="Social Image"
            width={50}
          />
        </StyledLink>
        : null
      }
    </StyledFlex>
  )
}

export default SocialLinks